<template>
    <div id="overview" class="container-fluid zoom">
        <div class="card">
            <div class="card-body">
                <b-row class="my-1">
                    <b-col sm="1">
                        <label for="filterInput">Filter:</label>
                    </b-col>
                    <b-col sm="9">
                        <b-input-group size="sm">
                        <b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search" size="sm"></b-form-input>
                        <b-input-group-append>
                            <b-button :disabled="!filter" @click="filter = ''" style="margin:0;">Clear</b-button>
                        </b-input-group-append>
                        </b-input-group>
                    </b-col>
                    <b-col sm="2">
                        <!-- TODO: change variant/css to nicer colors-->
                        <b-button @click="$router.push({name: 'New Booking'})" size="sm" style="margin:0;" variant="primary" class="pull-right">Create New booking</b-button>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="12" class="my-1">
                        <b-table
                            headVariant="dark"
                            table-variant="primary"
                            responsive
                            outlined
                            bordered
                            small
                            hover
                            show-empty
                            primary-key="ID"
                            :items="rows"
                            :fields="columns"
                            :busy="isBusy"
                            :filter="filter"
                            :per-page="perPage"
                            :current-page="currentPage"
                            @row-clicked="rowDblClk"
                        >
                            <template v-slot:table-busy>
                                <div class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Loading...</strong>
                                </div>
                            </template>
                            <template v-slot:empty="scope">
                                <h4>{{ scope.emptyText }}</h4>
                            </template>
                            <template v-slot:emptyfiltered="scope">
                                <h4>{{ scope.emptyFilteredText }}</h4>
                            </template>
                        </b-table>
                        <b-pagination v-model="currentPage" :total-rows="itemCount" :per-page="perPage" align="center" size="sm" class="my-0"></b-pagination>
                    </b-col>
                </b-row>
            </div>
        </div>
        <div class="fill">
            <img :src="bgPath" alt="bgPath">
        </div>
    </div>
</template>

<script>
import { WebEvent } from "../services/webEvent";
import moment from "moment";
import { AuthService } from "../services/auth-service";

export default {
    name: "Overview",
    async created() {
        await this.initialize();
    },
    beforeDestroy() {
        WebEvent.unsubscribe(this.webEventSubject);
        WebEvent.disconnect();
    },
    data() {
        return {
            columns: [],
            rows: [],
            filter: "",
            currentPage: 1,
            totalRows: this.itemCount,
            perPage: 10,
            isBusy: false,
            webEventSubject: "",
            bgPath: process.env.VUE_APP_BG_PATH,
        };
    },
    timers: {
        log: { time: 30000, autostart: false },
    },
    methods: {
        log() {
            console.warn("30 seconds passed from last websocket message!");
            this.rows = [];
            this.showModalMessage("The server is not responding, try refresh the page.");
        },
        showLoader() {
            this.$bus.$emit("showLoader");
        },
        hideLoader() {
            this.$bus.$emit("hideLoader");
        },
        showModalMessage(msg) {
            return this.$bvModal
                .msgBoxOk(msg, {
                    title: "Information",
                    size: "sm",
                    buttonSize: "sm",
                    okVariant: "success",
                    headerClass: "p-2 border-bottom-0",
                    footerClass: "p-2 border-top-0",
                    centered: true,
                })
                .catch((err) => {
                    console.error(err);
                });
        },
        rowDblClk(item) {
            //index, event
            this.$router.push({ name: "RentalDetail", params: { id: item.ID } });

        },
        initialize() {
            // this.populateData(dummyData);

            this.showLoader();
            WebEvent.unsubscribe(this.webEventSubject);
            WebEvent.disconnect();
            if (WebEvent.available()) {
                WebEvent.onNotify = (event) => {
                    this.populateData(event.data);
                    this.hideLoader();
                    this.$timer.stop("log");
                    this.$timer.start("log");
                };
                WebEvent.onError = (error) => {
                    console.error(error);
                };
                WebEvent.onConnect = () => {
                    console.log("overview onConnect.");
                    const dateFrom = moment()
                        .subtract(1, "month")
                        .format("YYYYMMDD");
                    const dateTo = moment()
                        .add(1, "month")
                        .format("YYYYMMDD");
                    const datePart = dateFrom + "." + dateTo;
                    const userPart = AuthService.getStoredUserProfile().username;
                    this.webEventSubject = "no.agile.autoleie.reservations." + datePart + "." + userPart;
                    WebEvent.subscribe(this.webEventSubject);
                };

                WebEvent.connect();
            }
        },
        populateData(eventData){
            const data = JSON.parse(eventData);
            this.columns = this.createColumns(data.names);
            this.rows = this.createRows(data);
        },
        createColumns(columns) {
            if (!columns) return [];
            const result = [];
            columns.forEach((c) => {
                if (c != "ID") {
                    const column = {
                        key: c,
                        sortable: true,
                    };
                    result.push(column);
                }
            });

            return result;
        },
        createRows(data) {
            if (!data || !data.values) return [];
            const result = [];
            data.values.forEach((r) => {
                let row = new Object();
                for (let index = 0; index < r.length; index++) {
                    const value = r[index];
                    const property = data.names[index];
                    row[property] = value;
                }
                result.push(row);
            });

            return result;
        },
    },
    computed: {
        itemCount() {
            return this.rows.length;
        },
    },
};
</script>
